import { useState, useEffect } from 'react'
import { Container } from '@ui/wrapper'
import { SectionWrapper, StyledText, OwnTh, OwnTd } from './style'
import logo from '../../../assets/images/logo/dark-logo-2.svg'
import { Spinner } from 'react-bootstrap'
import './style.css'
import { usePageContext } from '@context/PageContext'
import { texts } from '@constants/credit-default-swaps'
import { localizedDecimal } from '@utils'

let localeTexts

const CreditDefaultSwapsArea = ({ ...rest }) => {
  const [loading, setLoading] = useState(true)
  const [cdsData, setCdsData] = useState(null)
  const [comments, setComments] = useState(null)
  const [refDateStr, setRefDateStr] = useState('')

  const { locale } = usePageContext()

  localeTexts = texts[locale] || texts.de

  let footnoteIndex = 1

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch('/api/data/cds')
        if (!res.ok) {
          throw new Error('Error fetching cds data')
        }
        const r = await res.json()
        setCdsData(r)
        setComments(r.filter((el) => el['footer_' + locale]))
        const refDateArr = r
          .filter((obj) => obj.ref_date)
          .reduce((max, obj) => (obj.ref_date > max.ref_date ? obj : max), {
            ref_date: '1900-01-01'
          })
          ?.ref_date?.split('T')[0]
          .split('-')
        setRefDateStr(`${refDateArr[2]}.${refDateArr[1]}.${refDateArr[0]}`)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  return (
    <SectionWrapper {...rest}>
      <Container>
        <StyledText>
          {loading && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
                color: '#00408a'
              }}
            >
              <Spinner animation="border" />
            </div>
          )}
          {!loading && !cdsData && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
                color: '#00408a'
              }}
            >
              <span>{localeTexts.noData}</span>
            </div>
          )}
          {!loading && cdsData && (
            <>
              <table>
                <thead>
                  <tr>
                    <th
                      style={{
                        transformOrigin: 'left',
                        transform: 'scaleX(1.004)'
                      }}
                    >
                      <h5> {localeTexts.company} </h5>
                    </th>
                    <OwnTh
                      style={{
                        transformOrigin: 'right',
                        transform: 'scaleX(1.004)'
                      }}
                    >
                      <h5> {localeTexts.cdsPrice} </h5>
                    </OwnTh>
                  </tr>
                </thead>
                <tbody>
                  {cdsData?.map((item, index) => {
                    let price = item.price
                      ? localizedDecimal(item.price.toFixed(2), locale)
                      : '---'
                    return (
                      <tr key={index}>
                        <td style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ display: 'inline-block' }}>
                            {item.name}
                            {item.display_group === 'BSW' && (
                              <span style={{ marginLeft: 5 }}>
                                |{' '}
                                <img
                                  style={{
                                    height: 13,
                                    marginBottom: 3,
                                    marginLeft: 4
                                  }}
                                  src={logo}
                                  alt="BSW"
                                />
                              </span>
                            )}
                            <sup style={{ marginLeft: '5px' }}>
                              {item['footer_' + locale]
                                ? `${(footnoteIndex++).toString()})`
                                : ''}
                            </sup>
                          </div>
                        </td>
                        <OwnTd>{price}</OwnTd>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: 'grey'
                }}
              >
                <span
                  style={{
                    textAlign: 'left',
                    fontSize: '14px',
                    paddingLeft: 5
                  }}
                >
                  {localeTexts.asOf} {refDateStr}
                </span>
                <span
                  style={{
                    textAlign: 'right',
                    fontSize: '14px',
                    paddingRight: 5
                  }}
                >
                  {localeTexts.source}
                </span>
              </div>
            </>
          )}
          {comments?.length > 0 &&
            comments.map((comment, index) => {
              return (
                <div
                  key={index}
                  style={{ marginTop: 10, fontSize: '15px' }}
                >{` ${(index + 1).toString()}) ${comment['footer_' + locale]}`}</div>
              )
            })}
        </StyledText>
      </Container>
    </SectionWrapper>
  )
}

export default CreditDefaultSwapsArea
